import api from './index'

// 获取layering配置
export function getLayeringConfig(parameter) {
  return api('/api/options/layering', {
    data: parameter
  })
}